module.exports = __webpack_public_path__ + "img/应用场景_月度会议.c6b04a17.png";